import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Typography, Grid, TextField } from "@mui/material";
import CommonDialog from "../../common/commonDialog";

const useStyles = makeStyles((theme) => ({
  checkLabelFont: {
    marginLeft: "12px!important",
    color: "#292929!important",
    fontSize: "1rem!important",
  },
  checkFont: {
    display: "flex",
    justifyContent: "start",
    marginLeft: "0px!important",
  },
}));

const VendorTypeModal = (props) => {
  const classes = useStyles();

  const { open, onCancel, onSave, vendorTypeData, setVendorTypeData } = props;

  // Safety check: ensure vendorTypeData is always defined
  const safeVendorTypeData = vendorTypeData || {
    vendorTypeId: null,
    name: "",
    code: "",
    reconAccount: "",
    purchasingOrganisation: "",
    taxType: "",
    description: "",
    status: "Y",
    isEvaluationRequired: "Y",
  };

  const onInputChange = (event) => {
    const { name, value } = event.target;
    const updatedData = { ...safeVendorTypeData, [name]: value };
    setVendorTypeData(updatedData);
  };

  return (
    <CommonDialog
      onCancel={onCancel}
      onSave={onSave}
      open={open}
      primaryButtonLabel={"Save"}
      secondaryButtonLabel={"Cancel"}
      title={"Vendor Type"}
    >
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Name"
            name="name"
            type="text"
            size="small"
            value={safeVendorTypeData.name || ""}
            onChange={onInputChange}
          />
        </Grid>

        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Code"
            name="code"
            type="text"
            size="small"
            value={safeVendorTypeData.code || ""}
            onChange={onInputChange}
          />
        </Grid>

          <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Recon Account"
            name="reconAccount"
            type="text"
            size="small"
            value={safeVendorTypeData.reconAccount || ""}
            onChange={onInputChange}
          />
        </Grid>

          <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Purchasing Organisation"
            name="purchasingOrganisation"
            type="text"
            size="small"
            value={safeVendorTypeData.purchasingOrganisation || ""}
            onChange={onInputChange}
          />
        </Grid>

          <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Tax Type"
            name="taxType"
            type="text"
            size="small"
            value={safeVendorTypeData.taxType || ""}
            onChange={onInputChange}
          />
        </Grid>

        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            id="outlined-search"
            label="Description"
            name="description"
            multiline
            rows={2}
            value={safeVendorTypeData.description || ""}
            onChange={onInputChange}
          />
        </Grid>

         <Grid item sm={12} xs={12}>
          <FormControl>
            <FormLabel
              id="is-evaluation-required-label"
              className={classes.checkLabelFont}
            >
              Is Evaluation Required
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="is-evaluation-required-label"
              name="isEvaluationRequired"
              value={safeVendorTypeData.isEvaluationRequired ?? "Y"}
              onChange={onInputChange}
            >
              <FormControlLabel
                value="Y"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#f91e26",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 23,
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    variant="body1"
                    fontSize={15}
                    sx={{ color: "#292929" }}
                  >
                    YES
                  </Typography>
                }
                className={classes.checkFont}
              />
              <FormControlLabel
                value="N"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#f91e26",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 23,
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    variant="body1"
                    fontSize={15}
                    sx={{ color: "#292929" }}
                  >
                    NO
                  </Typography>
                }
                className={classes.checkFont}
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item sm={12} xs={12}>
          <FormControl>
            <FormLabel
              id="status-label"
              className={classes.checkLabelFont}
            >
              Status
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="status-label"
              name="status"
              value={safeVendorTypeData.status || "Y"}
              onChange={onInputChange}
            >
              <FormControlLabel
                value="Y"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#f91e26",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 23,
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    variant="body1"
                    fontSize={15}
                    sx={{ color: "#292929" }}
                  >
                    ACTIVE
                  </Typography>
                }
                className={classes.checkFont}
              />
              <FormControlLabel
                value="N"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#f91e26",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 23,
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    variant="body1"
                    fontSize={15}
                    sx={{ color: "#292929" }}
                  >
                    INACTIVE
                  </Typography>
                }
                className={classes.checkFont}
              />
            </RadioGroup>
          </FormControl>
        </Grid>

 
      </Grid>
    </CommonDialog>
  );
};
export default VendorTypeModal;
